import { throttle } from 'lodash-es';

export default function v1DestinationsHeader() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const isIE = !!(userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1);
  const elm = document.getElementsByClassName('v1-destinationsHeader__bodyArea')[0];

  const adjustLeft = () => {
    const windowWidth = window.innerWidth;
    const paddingLeft = (windowWidth - 1280) / 2 - 80;

    if (!elm) {
      return;
    }

    if (windowWidth > 1024) {
      elm.style.paddingLeft = `${paddingLeft}px`;
      return;
    }

    elm.style.paddingLeft = '';
  };

  window.addEventListener('load', () => {
    if (isIE) {
      adjustLeft();
    }
  });

  window.addEventListener(
    'resize',
    throttle(() => {
      if (isIE) {
        adjustLeft();
      }
    }, 1000 / 60),
  );
}
